import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

import { GqlProjectMetadata } from "./useMeGetProjectInfoQuery";
import { PROJECT_COST_GET_ALL } from "./useProjectCostGetAllForProject";

const PROJECT_COST_CREATE = gql(`
mutation ProjectCostCreate($input: GqlProjectCostCreateInput!) {
    projectCostCreate(input: $input) {
        data {
            ... on GqlSpeciesResearchCostSpec {
                type
                protocols {
                    id
                    name
                    total
                    visits {
                        id
                        number
                        minDuration
                        pricePerHour
                        total
                    }
                }
            }
        }
        id
        name
    }
}
`);

export default function useProjectCostCreate(project: GqlProjectMetadata) {
    const [projectCostCreate, { data, loading, error }] = useMutation(PROJECT_COST_CREATE, {
        refetchQueries: [PROJECT_COST_GET_ALL],
    });

    return {
        projectCostCreate: (name: string) =>
            projectCostCreate({
                variables: { input: { projectId: project.id, name } },
            }),
        loading,
        error,
        data: data?.projectCostCreate,
    };
}
